export default __webpack_public_path__ + "static/rec-2019-iii-284e88f8382703d220547083d32e2466.png";